import React, { lazy, Suspense } from "react";
const LazyListDeleteParadan = lazy(() => import("./ListDeleteParadan"));
const LazyListDeleteTakeMoney = lazy(() => import("./ListDeleteTakeMoney"));
const LazyListDeleteRent = lazy(() => import("./ListDeleteRent"));
const LazyListDeleteSell = lazy(() => import("./ListDeleteSell"));
const LazyListDeleteTenants = lazy(() => import("./ListDeleteTenants"));
export const ListDeleteTenants = () => (
  <Suspense fallback="loading...">
    <LazyListDeleteTenants />
  </Suspense>
);
export const ListDeleteParadan = () => (
  <Suspense fallback="loading...">
    <LazyListDeleteParadan />
  </Suspense>
);
export const ListDeleteTakeMoney = () => (
  <Suspense fallback="loading...">
    <LazyListDeleteTakeMoney />
  </Suspense>
);
export const ListDeleteRent = () => (
  <Suspense fallback="loading...">
    <LazyListDeleteRent />
  </Suspense>
);
export const ListDeleteSell = () => (
  <Suspense fallback="loading...">
    <LazyListDeleteSell />
  </Suspense>
);
